import React from "react";
import { useStateContext } from "../../../context/ContextProvider";
import useFadeInOnScroll from "../../../components/Effects/FadeInOnScroll";

import img1 from "../../../assets/images/services/4-1.png";
import img2 from "../../../assets/images/services/4-2.png";
import img3 from "../../../assets/images/services/4-3.png";
import img4 from "../../../assets/images/services/4-4.png";

const AdvertisingCampaigns = () => {

    const {
        isMobile
    } = useStateContext();

    useFadeInOnScroll();

    const cards = [
        {
            title: "Keyword Strategy: Keywords play a critical role in ensuring your ads reach the right people at the right time",
            image: img1,
        },
        {
            title: "Ad Formats: From display ads to video commercials, we offer diverse formats tailored to different platforms such as Google Ads, Instagram, and YouTube",
            image: img2,
        },
        {
            title: "Performance Tracking: Measuring campaign success is crucial. We provide detailed reports highlighting key metrics",
            image: img3,
        },
        {
            title: "Social Media Advertising: Platforms like Instagram, Facebook, and LinkedIn offer unparalleled opportunities to engage directly with audiences",
            image: img4,
        }
    ];

    const prolist = [
        {
            text: "Components of Our Advertising Services",
            active: true
        },
    ];
    return (
        <>
            <div className="w-full relative py-5 my-5 flex flex-col gap-5">
                <div className="h-[50px]"></div>
                {/* 1 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-1">
                    <div className="fade-element text:4xl md:text-5xl lg:text-6xl capitalize font-bold">
                        Advertising & Campaigns: Elevate Your Brand's Presence
                    </div>
                    <div className="w-full flex justify-end">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            In today’s competitive market, effective advertising campaigns are essential for businesses aiming to stand out and grow. At DO DEAL, we specialize in creating tailored advertising strategies that align with your business goals, ensuring maximum impact and measurable results.
                        </div>
                    </div>
                </div>
                {/* 2 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        What Makes a Successful Advertising Campaign?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            A successful campaign starts with clear objectives and a well-defined strategy.
                            <br />
                            By understanding your target audience, crafting compelling messages, and leveraging creative execution, we help your brand connect meaningfully with potential customers.
                        </div>
                    </div>
                </div>
                {/* 3 */}
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {prolist?.map((list, index) => (
                            <div
                                key={index}
                                className={`fade-element w-full border capitalize rounded-full font-bold p-3 ${list?.active && "bg-white text-black"}`}
                            >
                                {list?.text}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="relative padding-container w-full my-5 py-5 text-center z-1">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {cards?.map((card, index) => (
                            <div
                                key={index}
                                className={`fade-element relative w-full h-[350px] border border-[5px] rounded-[30px] capitalize overflow-hidden flex flex-col justify-end`}
                                style={{
                                    backgroundImage: `url("${card?.image}")`, backgroundSize: "cover", backgroundPosition: "center"
                                }}
                            >
                                <div className="absolute w-full h-full rounded-[30px]" style={{ background: "linear-gradient(180deg, #FFFFFF 0%, #000000 100%)", mixBlendMode: "multiply" }}></div>
                                <div className="absolute w-full h-full rounded-[30px] flex flex-col p-4 justify-end" style={{ zIndex: 1 }}>
                                    <div className="font-bold capitalize">{card?.title}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* 4 */}
                <div className="relative padding-container w-full my-5 py-5 text-start z-1 flex flex-col gap-4 text-base">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold">
                        Our approach focuses on:
                    </div>
                    <div className="fade-element ">
                        Clear Objectives: Defining what you want to achieve whether it’s increasing brand awareness, generating leads, or boosting sales.
                    </div>
                    <div className="fade-element ">
                        Target Audience Insights: Using tools like Google Analytics and Facebook Demographics to understand who your audience is and how they behave online .
                    </div>
                    <div className="fade-element ">
                        Creative Execution: Designing visually appealing ads that resonate emotionally and encourage action from viewers.
                    </div>
                </div>
                {/* 5 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-end">
                        Why Choose DO DEAL for Your Advertising Needs?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)]">
                            At DO DEAL, our team combines expertise in digital marketing, analytics, and creative design to deliver personalized solutions.
                            Whether you’re a small startup or an established enterprise, we adapt our strategies to fit your unique needs and budget constraints.
                            <br />
                            Additionally, our affordable pricing plans ensure quality services without breaking the bank.
                            We believe in transparency and collaboration, keeping you informed every step of the way.
                            <br />
                            Our goal is simple: to empower your business by creating impactful advertising campaigns that deliver tangible results.
                        </div>
                    </div>
                </div>
                {/* 6 */}
                <div className="relative padding-container w-full my-5 py-5 z-1 flex flex-col gap-4">
                    <div className="fade-element text:2xl md:text-3xl lg:text-4xl capitalize font-bold text-start">
                        Ready to take your advertising efforts to the next level?
                    </div>
                    <div className="w-full flex justify-center">
                        <div className="fade-element lg:max-w-[50%] min-w-[300px] text-xs md:text-sm text-justify text-[var(--l-gray)] mb-5">
                            Let DO DEAL be your trusted partner in achieving remarkable growth.
                            <br />
                            Contact us to discover how we can transform your brand’s presence through strategic advertising campaigns!
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdvertisingCampaigns;